(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "7806e50f590d5a97eeb969ffa21ce4e8bce647e4"
};